import script from "./Deploy.vue?vue&type=script&setup=true&lang=js"
export * from "./Deploy.vue?vue&type=script&setup=true&lang=js"

import "./Deploy.vue?vue&type=style&index=0&id=2f3b3f9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3b3f9c"]])

export default __exports__